import { isEscape, returnFocus, trapFocus, throttle } from "./utils.js";

var returnFocusTo = window.returnFocusTo || null;
let _releaseSearchFocusTrap = null;
let _releaseSubmenuFocusTrap = null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
Sticky Header
*/
function onWindowScroll() {
    if (window.scrollY > 50) {
        document.body.classList.add('scrolled');
    } else {
        document.body.classList.remove('scrolled');
    }
}
window.addEventListener('scroll', throttle(onWindowScroll, 200));
window.addEventListener('scrollend', onWindowScroll);
// incase we refresh down the page
onWindowScroll();

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        closeSearch();
        _releaseSubmenuFocusTrap?.();
        _releaseSubmenuFocusTrap = null;
        submenuToggles.forEach(el => {
            el.setAttribute('aria-expanded', false);
        });
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Mobile
*/
const siteMenuToggle = document.querySelector('.site-utilities__item--menu-toggle');
const submenuToggles = document.querySelectorAll('button.site-menu__link');
// buttons within the submenus that exit the entire menu
const submenuExitButtons = document.querySelectorAll('.submenu__exit');
// buttons within the submenus that exit the current menu
const submenuBackButtons = document.querySelectorAll('.submenu__back');

function closeSiteMenu() {
    document.body.classList.remove('site-menu-open');
    siteMenuToggle.setAttribute('aria-expanded', false);
    _releaseSubmenuFocusTrap?.();
    _releaseSubmenuFocusTrap = null;
}

// toggle site menu
siteMenuToggle.addEventListener('click', e => {
    if (document.body.classList.contains('site-menu-open')) {
        closeSiteMenu();
        return;
    }
    closeSearch();
    document.body.classList.add('site-menu-open');
    siteMenuToggle.setAttribute('aria-expanded', true);
    // on desktop, these break trap focus, so we only want them tabbable when the menu is open on mobile. maybe unnecessary?
    submenuExitButtons.forEach(el => {
        el.setAttribute('tabindex', 0);
    });
    submenuBackButtons.forEach(el => {
        el.setAttribute('tabindex', 0);
    });
});

// open submenu
submenuToggles.forEach(el => {
    el.addEventListener('click', e => {
        if (el.getAttribute('aria-expanded') === 'true') {
            el.setAttribute('aria-expanded', false);
            _releaseSubmenuFocusTrap?.();
            _releaseSubmenuFocusTrap = null;
            return;
        }
        el.setAttribute('aria-expanded', true);
        window.returnFocusTo = el;
        _releaseSubmenuFocusTrap = trapFocus(document.getElementById(el.getAttribute('aria-controls')), false);
    });
});

// exit entire menu
submenuExitButtons.forEach(el => {
    el.addEventListener('click', e => {
        closeSiteMenu();
        submenuToggles.forEach(el => {
            el.setAttribute('aria-expanded', false);
        });
    });
});

// navigate up/back
submenuBackButtons.forEach(el => {
    el.addEventListener('click', e => {
        el.closest('.site-menu__item').querySelector('.site-menu__link').setAttribute('aria-expanded', false);
    });
});

const searchToggles = document.querySelectorAll('[aria-controls="search"]');
function closeSearch() {
    document.body.classList.remove('search-open');
    searchToggles.forEach(el => {
        el.setAttribute('aria-expanded', false);
    });
    _releaseSearchFocusTrap?.();
    _releaseSearchFocusTrap = null;
}
searchToggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
        if (document.body.classList.contains('search-open')) {
            closeSearch();
            returnFocus();
            return;
        }
        window.returnFocusTo = toggle;
        document.body.classList.add('search-open');
        searchToggles.forEach(t => {
            t.setAttribute('aria-expanded', true);
        });
        _releaseSearchFocusTrap = trapFocus(document.getElementById('search'));
    });
});
